import { PictureMediaItem } from '@core/api';

export function extractErrorMessage(error: unknown, fallback: string): string {
  if (error && typeof error === 'object') {
    const maybeError = error as { error?: { message?: string }; message?: string };
    if (maybeError.error?.message) {
      return maybeError.error.message;
    }
    if (maybeError.message) {
      return maybeError.message;
    }
  }

  if (typeof error === 'string' && error.trim().length > 0) {
    return error;
  }

  return fallback;
}

export function parseRouteId(param: string | null, label: string): number {
  if (!param) {
    throw new Error(`${label} jest wymagane`);
  }

  const parsed = Number.parseInt(param, 10);
  if (Number.isNaN(parsed)) {
    throw new Error(`Nieprawidłowe ${label}`);
  }

  return parsed;
}

export function extractEntityId(result: unknown): number | null {
  if (typeof result === 'number' && Number.isFinite(result)) {
    return result;
  }

  if (result && typeof result === 'object') {
    const maybeObject = result as { id?: unknown };
    if (typeof maybeObject.id === 'number' && Number.isFinite(maybeObject.id)) {
      return maybeObject.id;
    }
  }

  return null;
}

export function toPictureMediaItems(input: unknown): PictureMediaItem[] {
  if (!Array.isArray(input)) {
    return [];
  }

  return input
    .map((item, index) => {
      if (typeof item === 'string') {
        return { src: item, order: index };
      }

      if (item && typeof item === 'object') {
        const maybePicture = item as { src?: unknown; name?: unknown; order?: unknown };
        const src = typeof maybePicture.src === 'string' ? maybePicture.src : '';
        const name = typeof maybePicture.name === 'string' ? maybePicture.name : undefined;
        const order = typeof maybePicture.order === 'number' ? maybePicture.order : index;
        return { src, name, order };
      }

      return { src: '', order: index };
    })
    .filter((picture) => typeof picture.src === 'string' && picture.src.trim().length > 0);
}
